import { useSuspenseQuery as useTanstackSuspenseQuery } from '@tanstack/react-query'
import type { FC } from 'react'
import { getQueryOptions } from '../../../services'
import type { ClientOutputs } from '@botpress/client'
import { useUsage } from '../../../hooks'
import { DYNAMIC_QUOTAS } from '../../usage/constants'
import { quotaTypes } from '@bpinternal/const'
import { partition } from 'lodash'
import { UsageProgressBar } from '../../../componentsV2'
import { StyledLink } from '../../../elementsv2'
type Props = {
  count?: number
  workspaceId: string
}

export const UsagePreview: FC<Props> = ({ count = 4, workspaceId }) => {
  const workspace = useTanstackSuspenseQuery(getQueryOptions('workspaces_/$workspaceId_', { workspaceId })).data

  // We don't want to show these quotas in the UI
  const excludedQuotas: ClientOutputs['getUsage']['usage']['type'][] = ['bing_search_spend', 'openai_spend']

  const usagesRecord = useUsage({
    workspaceId: workspace.id,
    quotas: [...DYNAMIC_QUOTAS, ...quotaTypes].filter((q) => !excludedQuotas.includes(q)),
  })

  const usages = [...Object.values(usagesRecord).filter((usage) => usage.value !== 0)].sort(
    (a, b) => b.percentage - a.percentage
  )

  const [highDynamicUsage, restUsages] = partition(
    usages,
    (usage) => DYNAMIC_QUOTAS.includes(usage.type as any) && usage.percentage > 50
  )

  return (
    <div className="flex flex-col gap-4">
      <span className="text-sm font-medium">Usages</span>
      {usages.length > 0 ? (
        <>
          <div className="flex flex-col gap-2 pr-4">
            {highDynamicUsage.map((usage) => (
              <UsageProgressBar key={usage.type} {...usage} />
            ))}
            {restUsages.slice(0, count - highDynamicUsage.length).map((usage) => (
              <UsageProgressBar key={usage.type} {...usage} />
            ))}
          </div>

          <StyledLink className="text-xs" to="/workspaces/$workspaceId/usage" params={{ workspaceId: workspace.id }}>
            View all usages
          </StyledLink>
        </>
      ) : (
        <span className="text-xs text-gray-11">
          {workspace.name} has no usage.
          <br />
          <br /> Start building and using bots, to see overview of your billing limits usage here.
        </span>
      )}
    </div>
  )
}
